module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/aiCreation/components/AiHotFilter/assets/black-arrow.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/aiCreation/components/AiHotFilter/assets/black-arrow.png
// module id = 1716
// module chunks = 367